import { documentDataPresenter } from '_/presenter';
import * as types from '../types';

export * from './user';

export const actionSucceeded = data => ({
  type: types.FETCH_PROCESS_SUCCEEDED,
  payload: data
});

export const actionFailed = error => ({
  type: types.FETCH_PROCESS_FAILED,
  payload: error
});

export const updateProcessDetail = policy => ({
  type: types.UPDATE_PROCESS,
  payload: policy
});

const getPolicyEndorsements = async (api, id) => {
  try {
    const { data } = await api.getPolicyEndorsements(id);
    return data || {};
  } catch (error) {
    return {};
  }
};
export const fetchProcessDetail = (id, params) => async (
  dispatch,
  getState,
  { PoliciesAPI }
) => {
  dispatch({ type: types.REQUEST_PROCESS_DETAILS });

  try {
    const { data, status } = await PoliciesAPI.getPolicyByIdentifyNumber(
      params
    );
    let backOfficeData = {};
    if (data && data.documentNumber) {
      backOfficeData = await getPolicyEndorsements(
        PoliciesAPI,
        data.documentNumber
      );
    }
    const allResponse = {
      status,
      data: {
        ...data,
        ...(backOfficeData.endorsements && {
          endorsements: backOfficeData && backOfficeData.endorsements
        })
      }
    };

    const presenterResponse = documentDataPresenter(allResponse);
    return dispatch(actionSucceeded(presenterResponse.data));
  } catch (error) {
    return dispatch(actionFailed(error));
  }
};
